import { render, staticRenderFns } from "./AgentDataTable.vue?vue&type=template&id=26bba1ce&"
import script from "./AgentDataTable.vue?vue&type=script&lang=js&"
export * from "./AgentDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26bba1ce')) {
      api.createRecord('26bba1ce', component.options)
    } else {
      api.reload('26bba1ce', component.options)
    }
    module.hot.accept("./AgentDataTable.vue?vue&type=template&id=26bba1ce&", function () {
      api.rerender('26bba1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Agent/AgentDataTable.vue"
export default component.exports